import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { DebounceinputComponent } from './debounceinput.component';
import { DebounceinputRoutingModule } from './debounceinput.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DebounceinputRoutingModule,
  ],
  exports: [
    DebounceinputComponent
  ],
  declarations: [
    DebounceinputComponent
  ],
})
export class DebounceinputModule { }
